import { createRouter, createWebHistory } from "vue-router";
import Sites from "./views/Sites.vue";
import Chargers from "./views/Chargers.vue";
import Easee from "./views/Easee.vue";
import Payouts from "./views/Payouts.vue";
import Profile from "./views/Profile.vue";
import Sessions from "./views/Sessions.vue";
import Site from "./views/Site.vue";

export default createRouter({
	history: createWebHistory(),
	routes: [{
		name: "home",
		path: "/my",
		component: Sites,
		meta: { title: "Mine Ladesteder" }
	}, {
		name: "easee",
		path: "/my/easee",
		component: Easee,
		meta: { title: "Velg ladested" }
	}, {
		name: "profile",
		path: "/my/profile",
		component: Profile,
		meta: { title: "Min Profil" }
	}, {
		name: "site",
		path: "/my/site/:id?",
		component: Site,
		meta: { title: "Ladested" },
		props: true
	}, {
		name: "chargers",
		path: "/my/site/:id/chargers",
		component: Chargers,
		meta: { title: "Ladepunkter" },
		props: true
	}, {
		name: "payouts",
		path: "/my/site/:id/payouts",
		component: Payouts,
		meta: { title: "Utbetalinger" },
		props: true
	}, {
		name: "sessions",
		path: "/my/site/:id/sessions",
		component: Sessions,
		meta: { title: "Historikk" },
		props: true
	}]
});
